import { useMemo } from 'react';
import { Edit, Form, Toolbar, useEditController } from 'react-admin';
import { CardContent } from '@mui/material';
import type { MemberSummary } from '@wwf/sdk';
import { MemberInputs } from './MemberInputs';
import { memberSummaryToInput } from '@domain/member';

export const MemberEdit = () => {
    const { record } = useEditController<MemberSummary>();
    const formRecord = useMemo(
        () => (record ? memberSummaryToInput(record) : undefined),
        [record]
    );

    return (
        <Edit actions={false} redirect="show" mutationMode="pessimistic">
            <Form record={formRecord}>
                <CardContent>
                    <MemberInputs />
                </CardContent>
                <Toolbar />
            </Form>
        </Edit>
    );
};
